define('plugin/membership/view/MembershipListView',['require','lib/view/BaseCollectionView','plugin/membership/view/MembershipItemView','plugin/membership/view/MembershipEmptyView'],function (require) {

    var Parent = require('lib/view/BaseCollectionView');
    var MembershipItemView = require('plugin/membership/view/MembershipItemView');
    var MembershipEmptyView = require('plugin/membership/view/MembershipEmptyView');

    /**
     * Membership collection view
     *
     * @class MembershipListView
     */
    return Parent.extend({

        _pageId: 'membership',

        emptyViewOptions: function () {
            return {
                'type': this.getOption('type'),
                'is_id_filter': this.getOption('filterData') && this.getOption('filterData').id ? true : false,
            };
        },
        childViewOptions: function (model, index) {
            var highlighted = false;
            if (this.getOption('highlighted') && this.getOption('highlighted') == model.get('id')) {
                highlighted = true;
            }

            return {
                highlighted: highlighted,
                serviceCollection: this.getOption('serviceCollection'),
            };
        },
        emptyView: MembershipEmptyView,
        childView: MembershipItemView,
        collectionEvents: {
            'sync': 'onSync'
        },

        onSync: function () {
            this.destroyChildren();
            this.render();
        },

        filter: function (child, index, collection) {
            var filter = this.getOption('filterData');
            if (filter && filter.services) {
                return _.intersection(child.get('services'), filter.services).length > 0;
            }

            if(filter && filter.id) {
                return child.get('id') == filter.id;
            }
            return true;
        }

    });

});
